// extracted by mini-css-extract-plugin
export var container = "Integrate-module--container---a5zI";
export var btn = "Integrate-module--btn--9IT9v";